import * as React from 'react'
import RadioContainer from './RadioButton.style'

type Props = {
  id: string,
  label: string,
  name: string,
  checked: boolean,
  onChange: Function,
  disabled?: boolean,
  className?: string,
}

/**
 * @name RadioButton
 * @param {object} props Component props
 * @param {string} props.id Input id
 * @param {string} props.label Input label
 * @param {string} props.name Input name
 * @param {boolean} props.checked Input checked
 * @param {function} props.onChange on change callback
 * @param {boolean} props.disabled Input disabled
 */

const RadioButton = ({ id, label, name, checked, onChange, disabled, className }: Props) => {
  const handleChange = () => {
    onChange({ checked: !checked })
  }

  return (
    <RadioContainer className={className}>
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        data-testid={`${id}-radio-input`}
      />
      {label && (
        <label className={disabled ? 'disabled' : ''} htmlFor={id}>
          {label}
        </label>
      )}
    </RadioContainer>
  )
}

RadioButton.defaultProps = {
  disabled: false,
  className: '',
}

export default RadioButton
